import React, {useState, useEffect} from 'react';
import CompressionControl from './components/CompressionsControl';
import DisquetteControl from './components/DisquetteControl';

import { ThreeInchDisk, ZipDisk } from './components/Diskettes';
import { TimelineMax, Power4, gsap } from "gsap";
import { CSSPlugin } from 'gsap/CSSPlugin'

import './App.scss';

gsap.registerPlugin(CSSPlugin)

function App() {
	let [howManyFoppy, setHowManyFloppy] = useState(false);
	let [isLoading, setIsLoading] = useState(false);

	const howManyFloppyDisk = (event) => {
		event.preventDefault();
		setIsLoading(true);
		console.log(event.target);

		let stockageValue = event.target.querySelector('input[type=text]').value;
		let compressionValue = event.target.querySelector('.compression-select').value;
		let floppySelected = event.target.querySelector('.disquette-type-select').value;

		

		//convert to mo 
		if(compressionValue === "ko") { // 1ko = 0.001 mo
			stockageValue = stockageValue / 1000
		} else if(compressionValue === "go") { // 1go = 1000 mo
			stockageValue =  stockageValue  * 1000;
		} else if(compressionValue === "to") { // 1to = 1000000 mo
			stockageValue =  stockageValue * 1000000;
		}

		let howManyFloppy = stockageValue / floppySelected;
		setHowManyFloppy(howManyFloppy);

	}

	const BuildFloppy = () => {	
		let floppys = [];
		for(let i = 0; i <= Math.round(howManyFoppy); i++) {
			if(i >= 14) break;

			let rdmLeft = Math.floor(Math.random() * (1000 + 800) ) - 800 + "%";
			let rdmLTop = Math.floor(Math.random() * (300 + 300) ) - 300 + "%";

			if(i >= 13) {
				floppys.push(<ThreeInchDisk key={i} result={howManyFoppy} left={rdmLeft} top={rdmLTop} />);
			} else {
				floppys.push(<ThreeInchDisk key={i} left={rdmLeft} top={rdmLTop}/>);
			}
		}

		return floppys;
	}

	useEffect(() => {
		if(howManyFoppy !== false) {
			setTimeout(() => {
				let shapes = document.querySelectorAll(".animateFloppy .floppyWrapper"), tl = new TimelineMax();
				shapes.forEach((item, index) => {
					if(index === shapes.length - 1) {
						tl.to(item,
						0.75, 
						{
							opacity:1, 
							rotation: 8,
							x: 0,
							y: 0,
						}, 
						index * 0.05)
					} else {
						tl.to(item,
						0.75, 
						{
							opacity:1, 
							rotation: Math.floor(Math.random() * (1 + 360 - -359) + -359),
							x: 0,
							y: 0,
						}, 
						index * 0.05)
					}
				});
					
				tl.staggerTo(shapes, .5, {css:{opacity:1, transformOrigin:"center center"}, delay:2.6, ease: Power4.easeOut}, 0.02);
			},1);
		}
	},[howManyFoppy])

  return (
    <div className="wrapper">
    	<div className="full-pan">
			<div className="cols">
				<div className="col form-col">
					<h1>Combien de disquettes</h1>
					<span className="baseline">
						Convertisseur de giga-octets en nombre de disquettes 3.5 pouces et autres formats de stockage obsolètes.
					</span>
					<form onSubmit={howManyFloppyDisk}>
						<div className="form-group">
							<input type="text" name="number" placeholder="EX: 42" />
							<CompressionControl/>
						</div>
						<span className="sep-line">
							… à stocker sur : 
						</span>
						<DisquetteControl />
						<button type="submit">Calculer</button>
					</form>
				</div>
				<div className="col diskette-col">
					<div className="diskettes">
						{!isLoading ? (
							<div>
								<ThreeInchDisk />
								<ThreeInchDisk />
							</div>
						) : (
							<div className="animateFloppy">
								<BuildFloppy />
							</div>
						)}
						
					</div>
				</div>
			</div>
		</div>

		<footer>
			<div className="cols">
				<div className="col">
					<h3>A propos</h3>
					<p>Pour les plus jeunes d'entre vous, les disquettes (floppy disks en anglais) sont un support de stockage informatiques amovible qui a connu son âge d'or dans les années 80 et qui fut remplacé par les CD-Rom, les clés USB et maintenant le Cloud.</p>

					<p>Pour en savoir plus :<br/>
					fr.wikipedia.org/wiki/Disquette</p>

					<p>Le projet "ça fait combien de disquettes" est né d'une discussion avec notre stagiaire né fin des années 90, qui n'a pas connu les disquettes, ni les modems 56k... On se fait vieux. :D</p>
				</div>
				<div className="col">
					<h3>Qui sommes-nous ?</h3>
					<p>Modulo conçoit et réalise des projets digitaux sur-mesure en collaboration avec les équipes SI et métier.
					<br/><br/>
					Pour en savoir plus :<br/>
					www.modulodigital.com</p>
				</div>
				<div className="col">
					<h3>Crédits</h3>
					<p>
						Concept : Benjamin, François, Khaled et Rémi autour d'une bière au Plomb du Cantal.
						Design : Rémi
						Photos :
						Développement : Benjamin

						Pictogrammes : 

						Typographie (Google Fonts) :
						- Montserrat
						- Permanent Marker</p>
				</div>
			</div>
		</footer>
    </div>
  );
}

export default App;
